import React, {FormEvent, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import CustomButton from "../custom-button/custom-button";
import CustomButtonGroup from "../custom-button-group/custom-button-group";
import CustomRow from "../custom-row/custom-row";
import {changePageTitle, setAlert} from "../redux/actions";
import * as StringUtil from "../util/string-util";
import {FileUtil} from "../util/file-util";
import CustomTextField from "../custom-text-field/custom-text-field";
import {ProductService} from "../../product/product.service";
import SelectOption from "../select-option/select-option";

const BarCodes = () => {
    const dispatch = useDispatch();
    const [startId, setStartId] = useState('');
    const [endId, setEndId] = useState('');
    const [productIds, setProductIds] = useState('');
    const [type, setType] = useState<'product' | 'category' | 'productIds'>('product');
    const typeOptions = [
        {name: 'product', description: 'Produto inicial e final'},
        {name: 'category', description: 'Categoria inicial e final'},
        {name: 'productIds', description: 'IDs de produtos separados por vírgula'}
    ]

    useEffect(() => {
        dispatch(changePageTitle("Código de barras"));
    }, [dispatch]);

    const print = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        ProductService.getBarCodes(startId, endId, type, productIds).then(function (result) {
            FileUtil.openPdfInNewTab(result);
        }, (result) => {
            const error = StringUtil.decodeUint8Array(result);
            dispatch(setAlert({show: true, message: error.message, severity: 'error'}));
        })
    }

    const onChangeStartId = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStartId(event.target.value);
    }

    const onChangeProductIds = (event: React.ChangeEvent<HTMLInputElement>) => {
        setProductIds(event.target.value);
    }

    const onChangeEndId = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEndId(event.target.value);
    }

    const renderInitialAndFinalIds = () => {
        return (type === "product" || type === "category") && (
            <CustomRow>
                <CustomTextField autoFocus fullWidth label="ID Inicial" value={startId} onChange={onChangeStartId}
                                 type="number" inputProps={{min: 0, max: 99999999, step: 1}} required/>
                <CustomTextField fullWidth label="ID Final" value={endId} onChange={onChangeEndId}
                                 type="number" inputProps={{min: 0, max: 99999999, step: 1}} required/>
            </CustomRow>
        )
    }

    const renderIds = () => {
        return (type === "productIds") && (
            <CustomRow>
                <CustomTextField autoFocus fullWidth label="IDs" value={productIds} onChange={onChangeProductIds}
                                 type="text" inputProps={{min: 0, max: 99999999, step: 1}} required multiline rows={4}/>
            </CustomRow>
        )
    }

    return (
        <form onSubmit={print}>
            <SelectOption fullWidth required label="Tipo" value={type}
                          onChange={(event) => setType(event.target.value)}
                          items={typeOptions} itemValue='name' itemDescription='description'/>
            {renderInitialAndFinalIds()}
            {renderIds()}
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Imprimir</CustomButton>
            </CustomButtonGroup>
        </form>
    );
}

export default React.memo(BarCodes);